<div class="row">
    <form [formGroup]="formulario">
        <div *ngIf="enablePrevia" class="col-md col-lg" style="min-width: 930px;">
            <mat-card>
                <div *ngIf="enableApprovedPrevia">
                    <p>- De acordo com a prévia, o lote está aprovado. Fazer regulagem branda para minimizar perdas, mas
                        tentar melhorar a condição do material retirando defeitos mais severos.
                    </p>
                </div>

                <div *ngIf="enableSelection">
                    <p>- Selecione abaixo a foto que mais se parece com o defeito presente no
                        lote
                        para gerar recomendação:</p>
                    <!--div *ngIf="enableFuradasSeveras">
                        <div id="furadoLabel">
                            <p><b>Furados Severos:</b></p>
                        </div>

                        <mat-radio-group formControlName="tipo_furado" class="example-radio-group">
                            <mat-radio-button class="example-radio-button" value="0"
                                (change)="changeTipoDefeito($event)">
                                <div>
                                    Furo pequeno no embrião
                                    <br>
                                    <img style="max-height: 125px;" src="../../../assets/furadoEmbriao.png">
                                </div>
                            </mat-radio-button>
                            <mat-radio-button class="example-radio-button" value="1"
                                (change)="changeTipoDefeito($event)">
                                <div>
                                    Furado severo
                                    <br>
                                    <img style="max-height: 125px;" src="../../../assets/furadoSeveroI.png">
                                    &nbsp;
                                    <img style="max-height: 125px;" src="../../../assets/furadoSeveroII.png">
                                </div>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div-->
                    <div *ngIf="enableSilkCutSeveras">
                        <div id="poppedKernelSeverasLabel">
                            <p><b>Silk Cut Severos:</b></p>
                        </div>

                        <mat-radio-group formControlName="tipo_silk_cut" class="example-radio-group">
                            <mat-radio-button class="example-radio-button" value="0"
                                (change)="changeTipoDefeito($event)">
                                <div>
                                    Pouca diferença de cor/densidade
                                    <br>
                                    <img style="max-height: 125px;" src="../../../assets/silkCutSemCor.png">
                                </div>
                            </mat-radio-button>
                            <mat-radio-button class="example-radio-button" value="1"
                                (change)="changeTipoDefeito($event)">
                                <div>
                                    Com diferença de cor/densidade
                                    <br>
                                    <img style="max-height: 125px;" src="../../../assets/silkCutComCorI.png">
                                    &nbsp;
                                    <img style="max-height: 125px;" src="../../../assets/silkCutComCorII.png">
                                </div>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div *ngIf="enablePoppedKernelSeveras">
                        <div id="poppedKernelSeverasLabel">
                            <p><b>Popped Kernel Severos:</b></p>
                        </div>

                        <mat-radio-group formControlName="tipo_popped_kernel_severas" class="example-radio-group">
                            <mat-radio-button class="example-radio-button" value="0"
                                (change)="changeTipoDefeito($event)">
                                <div>
                                    Com diferença de densidade
                                    <br>
                                    <img style="max-height: 125px;" src="../../../assets/poppedKernelSemCor.png">
                                </div>
                            </mat-radio-button>
                            <mat-radio-button class="example-radio-button" value="1"
                                (change)="changeTipoDefeito($event)">
                                <div>
                                    Com diferença de cor
                                    <br>
                                    <img style="max-height: 125px;" src="../../../assets/poppedKernelComCor.png">
                                </div>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div *ngIf="enablePoppedKernelLeves">
                        <div id="poppedKernelLevesLabel">
                            <p><b>Popped Kernel Leves:</b></p>
                        </div>

                        <mat-radio-group formControlName="tipo_popped_kernel_leves" class="example-radio-group">
                            <mat-radio-button class="example-radio-button" value="0"
                                (change)="changeTipoDefeito($event)">
                                <div>
                                    Pouca diferença de cor
                                    <br>
                                    <img style="max-height: 125px;" src="../../../assets/poppedKernelLeveSemCor.png">
                                </div>
                            </mat-radio-button>
                            <mat-radio-button class="example-radio-button" value="1"
                                (change)="changeTipoDefeito($event)">
                                <div>
                                    Com diferença de cor
                                    <br>
                                    <img style="max-height: 125px;" src="../../../assets/poppedKernelLeveComCorI.png">
                                    &nbsp;
                                    <img style="max-height: 125px;" src="../../../assets/poppedKernelLeveComCorII.png">
                                </div>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                </div>

                <div *ngIf="enableSugestaoMuitasPassadas">
                    <p><b>Não é possível aprovar o lote com um número razoável de passadas.</b> Alinhar com times de
                        operações e QP a melhor estratégia para o lote
                    </p>
                </div>

                <div *ngIf="!enableSelection && enableTable">
                    <p><b>Estratégia Sugerida:</b></p>
                    <div *ngIf="enableNumeroPassagens && !enableSugestaoMuitasPassadas">
                        <p *ngIf="isPassadaPrevia"><b>Nº de passadas:</b> Com base no % de defeitos informado, o lote
                            pode ser aprovado com
                            {{textoPassadas}}
                        </p>
                        <p *ngIf="!isPassadaPrevia"><b>Nº de passadas:</b> Com base no % de defeitos informado, o lote
                            pode ser aprovado com mais
                            {{textoPassadas}}
                        </p>
                    </div>

                    <div *ngIf="enableDefeitosFoco">
                        <p *ngIf="isPassadaPrevia"><b>Defeitos foco:</b> Sugere-se focar a regulagem do <b>primeiro
                                passe</b> nos seguintes
                            defeitos:</p>

                        <p *ngIf="!isPassadaPrevia"><b>Defeitos foco:</b> Sugere-se focar a regulagem do <b>próximo
                                passe</b> nos seguintes
                            defeitos:
                        </p>

                        <div *ngFor="let item of defeitosFoco">
                            <p>- {{item.showEquip}}: {{item.showName}};
                            </p>
                        </div>
                    </div>

                    <div>
                        <div *ngIf="enableTable">
                            <p *ngIf="isPassadaPrevia"><b>Valores de defeitos a serem atingidos em cada passada:</b></p>
                            <p *ngIf="!isPassadaPrevia"><b>Valores de defeitos das passadas anteriores e valores a serem
                                    atingidos nas próximas passadas:</b></p>

                            <table mat-table [dataSource]="dataSource" class="w-100">

                                <ng-container matColumnDef="numero_passada">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Nº Passada
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellNoWrap">
                                        {{formatPassada(row)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="equip">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Equipamento
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'equip', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{row.equip}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="valores">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Status
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellNoWrap">
                                        {{getTipoPassada(row.tipo_passada)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="ardidas_leves">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Ardidas
                                        Leves
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'ardidas_leves', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.ardidas_leves)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="ardidas_severas">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Ardidas
                                        Severas
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'ardidas_severas', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.ardidas_severas)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="furadas_leves">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Furadas
                                        Leves
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'furadas_leves', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.furadas_leves)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="furadas_severas">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Furadas
                                        Severas
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'furadas_severas', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.furadas_severas)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="popped_kernel_leves">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Popped
                                        Kernel Leves
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'popped_kernel_leves', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.popped_kernel_leves)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="popped_kernel_severas">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Popped
                                        Kernel Severas
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'popped_kernel_severas', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.popped_kernel_severas)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="quebradas_leves">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Quebradas
                                        Leves
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'quebradas_leves', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.quebradas_leves)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="quebradas_severas">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Quebradas
                                        Severas
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'quebradas_severas', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.quebradas_severas)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="silk_cut_leves">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Silk Cut
                                        Leves
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'silk_cut_leves', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.silk_cut_leves)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="silk_cut_severas">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Silk Cut
                                        Severas
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'silk_cut_severas', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.silk_cut_severas)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="inerte_severas">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Inerte </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellText(row, 'inerte_severas', isPassadaPrevia)"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.inerte_severas)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="leves_total">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Total Leves
                                    </th>
                                    <td mat-cell *matCellDef="let row" [ngClass]="formatCellTotal(row, 'leves_total')"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.leves_total)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="severas_total">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Total
                                        Severas
                                    </th>
                                    <td mat-cell *matCellDef="let row" [ngClass]="formatCellTotal(row, 'severas_total')"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.severas_total)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="defeitos_total">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Total
                                        Defeitos
                                    </th>
                                    <td mat-cell *matCellDef="let row"
                                        [ngClass]="formatCellTotal(row, 'defeitos_total')"
                                        class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.defeitos_total)}}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="remocao_prc">
                                    <th mat-header-cell *matHeaderCellDef
                                        class="InputLabelHeaderColor formatFieldReport color-general-info"> Remoção (%)
                                    </th>
                                    <td mat-cell *matCellDef="let row" class="formatFieldReport formatCellNoWrap">
                                        {{formatOneDecimals(row.remocao_prc)}}
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row [ngClass]="formatRowColor(row)"
                                    *matRowDef="let row; columns: displayedColumns;"></tr>

                                <!-- Row shown when there is no matching data. -->
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell text-center" colspan="100%"><i
                                            class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i>
                                        Nenhum
                                        registro
                                        encontrado</td>
                                </tr>
                            </table>
                        </div>

                        <div *ngIf="enableTable">
                            <p class="legend-font"><span
                                    class="color-lightcoral">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                Defeito foco da regulagem da <b>próxima passada</b>
                            </p>
                            <p *ngIf="!isPassadaPrevia" class="legend-font">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="color-red">
                                    Defeito com remoção abaixo do esperado / Equipamento utilizado diferente do
                                    recomendado
                                </span>
                            </p>
                            <p class="legend-font">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                    class="color-darkred">
                                    Defeitos reprovados de acordo com o padrão de aprovação
                                </span>
                            </p>
                            <p class="legend-font">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                                    class="color-green">
                                    Defeitos aprovados de acordo com o padrão de aprovação
                                </span>
                            </p>
                        </div>
                    </div>

                    <br>
                    <div *ngIf="enableDefeitosAcima">
                        <p>Obs: Caso a peneira tenha menos de 5000 kg, avaliar com especialista e líder a possibilidade
                            de descarte da peneira (defeitos acima de 15%);
                        </p>
                    </div>
                    <div *ngIf="enableSugestaoDensimetrica && !enableSugestaoMuitasPassadas">
                        <p *ngIf="isPassadaPrevia">Obs: Caso a densimétrica esteja disponível, é possível aprovar o lote
                            com apenas 1 passe;
                        </p>
                        <p *ngIf="!isPassadaPrevia">Obs: Caso a densimétrica esteja disponível, é possível aprovar o
                            lote com apenas mais 1 passe;
                        </p>
                    </div>
                    <div *ngIf="enableSugestaoColunaColor && !enableSugestaoMuitasPassadas">
                        <p *ngIf="isPassadaPrevia">Obs: Caso a densimétrica esteja em uso, o lote pode ser aprovado na
                            coluna e color com
                            {{passadasColunaColorOriginal}} passada(s);
                        </p>
                        <p *ngIf="!isPassadaPrevia">Obs: Caso a densimétrica esteja em uso, o lote pode ser aprovado na
                            coluna e color com mais
                            {{passadasColunaColorOriginal}} passada(s);
                        </p>
                    </div>
                    <div *ngIf="enableSugestaoIneficiente">
                        <p>Obs: Os defeitos presentes no lote normalmente não são removidos pelos equipamentos. Checar
                            com QP/Processos uma estratégia alternativa.
                        </p>
                    </div>
                </div>
                <mat-card-actions class="text-right">
                    <button mat-button mat-flat-button color="accent" matTooltip="Continuar"
                        (click)="selectCheck(isPassadaPrevia);" *ngIf="enableSelection"
                        [disabled]="isButtonDisabled()"><i class="fa fa-check" aria-hidden="true"></i>
                        Continuar</button>
                    <button mat-button mat-flat-button color="accent" matTooltip="Salvar Estratégia"
                        (click)="saveSuggestion()" *ngIf="!enableSelection"><i class="fa fa-check"
                            aria-hidden="true"></i> Salvar
                        Estratégia</button>
                    <button mat-button mat-flat-button color="accent" matTooltip="Fechar" (click)="closeModal();"><i
                            class="fa fa-close" aria-hidden="true"></i>
                        Fechar</button>
                </mat-card-actions>
            </mat-card>
        </div>

        <div *ngIf="enableEficiencia" class="col-md col-lg">
            <mat-card>
                <div *ngIf="enableApprovedEfic">
                    <p>- De acordo com os dados informados, o lote está aprovado com a regulagem atual.
                    </p>
                </div>

                <div *ngIf="enablePassadaAnteriorInexistente">
                    <p>- Não há registros da passada {{passadaAnteriorPrevia}}. Para ver recomendações de regulagem,
                        preencher
                        os dados faltantes.
                    </p>
                </div>

                <div *ngIf="!enableApprovedEfic">
                    <div *ngIf="enableErrorExists">
                        <p> Remoção abaixo do esperado. Seguir orientações abaixo avaliando visualmente a melhora na
                            bica
                            boa de cada equipamento.
                        </p>

                        <div *ngIf="enableShapeText">
                            <p><b>Shape:</b> Baixa remoção de <b>{{defeitoShapeText}}</b> - Selecionar outros
                                <b>{{defeitoShapeText}}</b> e comparar as
                                características de formato para melhorar regulagem.
                            </p>
                        </div>

                        <div *ngIf="enableColorText">
                            <p><b>Color Sorter:</b> Baixa remoção de <b>{{defeitoColorText}}</b>. Ajustar a
                                sensibilidade e/ou
                                área do defeito e confirmar com o botão de check (luz amarela).
                            </p>
                        </div>

                        <div *ngIf="enableColunaText">
                            <p><b>Coluna de ar:</b> Baixa remoção de <b>{{defeitoColunaText}}</b></p>
                            <p>- Aumentar fluxo de ar dos ventiladores +3Hz;</p>
                            <p>- Conferir o repasse - se a perda aumentar muito, reduzir fluxo de ar;</p>
                            <p>- Ajustar defletor interno para reduzir a força do ar de repasse;</p>
                            <p>- Abrir gradualmente a porta de alívio do repasse (ajustes de 2cm);</p>
                            <p>- Conferir defeitos na saída de semente boa do repasse;</p>
                            <p>- Realizar uma nova avaliação e lançar no Datapipeline para conferir eficiência da
                                passada.</p>
                        </div>

                        <div *ngIf="enableMGTText && !isDefeitoMGTDetailsPrevia">
                            <p><b>Densimétrica:</b> Baixa remoção de <b>{{defeitoMGTText}}</b> {{defeitoMGTDetails}}
                            </p>
                        </div>

                        <div *ngIf="enableMGTText && isDefeitoMGTDetailsPrevia">
                            <p><b>Densimétrica: </b> {{defeitoMGTDetails}}
                            </p>
                        </div>
                    </div>
                    <div *ngIf="!enableErrorExists && !enablePassadaAnteriorInexistente">
                        <p>O lote ainda está reprovado, mas a remoção dos defeitos está dentro do esperado com a
                            regulagem
                            atual.
                        </p>
                    </div>
                </div>

                <div *ngIf="isPerdaSementesBoas">
                    <p>
                        <b>Perda: A perda de sementes boas está acima do normal. Atenção às regulagens para não perder
                            muito rendimento.</b>
                    </p>
                </div>
                <mat-card-actions class="text-right">
                    <button mat-button mat-flat-button color="accent" matTooltip="Gerar Estratégia"
                        (click)="rebuildEstrategia()" *ngIf="!enableApprovedEfic"><i class="fa fa-check"
                            aria-hidden="true"></i> Gerar
                        Estratégia</button>
                    <button mat-button mat-flat-button color="accent" matTooltip="Fechar" (click)="closeModal();"><i
                            class="fa fa-close" aria-hidden="true"></i>
                        Fechar</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </form>
</div>